<template>
  <!-- Collapsed State -->
  <div v-if="collapsed"  class="camp-open-theme-zone">
    <label class="btn secondary no-dark-mode camp-toogle-theme-bt camp-toogle-open-theme-bt" @click="toggleCollapse">
      <i class="bi bi-chevron-double-right"></i>
    </label>    
    <div class="tooltip1">
      <p>Pour plus de personnalisation, cliquez ici !</p>
    </div>  
  </div>
  <div v-else class="camp-theme-card ">
    <!-- Chevron Collapse Button -->
    <div class="camp-close-theme-bt">
      <label class="btn secondary no-dark-mode camp-toogle-theme-bt camp-toogle-close-theme-bt" @click="toggleCollapse">
        <i class="bi bi-chevron-double-left"></i>
      </label>
    </div>
    <!-- Description, Section -->
    <div class="camp-theme-title">Personnalisation de page (facultatif)</div>
    <div class="camp-theme-text">
      Modifiez votre page de campagne et sublimez votre marque.
    </div>
    <!-- Select campaign, Section -->
    <div class="camp-theme-title">Reprendre la page personnalisée d’une campagne existante</div>
    <div class="camp-theme-text" v-if="campaignCount==1">
      Aucune campagne existante pour le moment, veuillez configurer une nouvelle page personnalisée.
    </div>
    <div v-else>
      <div class="camp-theme-select-title">Thème</div>
      <v-select
                class="camp-theme-selector"
                v-model="selectedCampaign" 
                label="name"
                placeholder="Choisissez un thème déjà existant"
                :searchable="true"
                :clearable="false"
                :options="campaignList"
                @update:model-value="selectCampaign"
              />
      <div class="camp-theme-text"></div>
    </div>
    <!-- File Upload Section -->
    <div class="camp-theme-title">Configurer une nouvelle page personnalisée</div>
    <div class="camp-theme-upload-title">Image de fond de la page</div>
    <div class="camp-theme-upload-selector">
        <label for="fileInput" class="camp-theme-upload-selector-bt">Choisir un fichier</label>
        <input
          type="file"
          id="fileInput"
          class="camp-theme-upload-input"
          accept="image/png, image/jpeg, image/gif"
          @change="handleFileUpload"
        />
        <input
          type="text"
          :value="fileName"
          class="camp-theme-upload-file-name"
          readonly
        />  
        <img v-if="fileSelected" class="camp-theme-remove-file" src="@/assets/images/icon/remove_bg.svg" @click="removeBackground"/>      
 
    </div>
    <div class="camp-theme-upload-file-info ">
      Le fichier téléchargé sert d'image de fond. Assurez-vous qu'il soit de bonne qualité (1920x1080).
    </div>
    <!-- Colour Picker Section -->
    <div class="camp-theme-colour-section">
      <div>
        <div class="camp-theme-colour-title">Couleur des éléments</div>
          <div class="camp-theme-colour-subsection">
          <input
            type="color"
            v-model="elemColour"
            id="bgColorPicker"
            class="camp-theme-colour-picker"
          />
          <input
            type="text"
            v-model="elemColour"
            class="camp-theme-colour-code"
            placeholder="#f2cb36"
            maxlength="7"
          />

        </div>
      </div>
      <div>
        <div class="camp-theme-colour-title">Couleur des textes</div>
        <div class="camp-theme-text-colour">
          <input
            type="radio"
            id="textWhite"
            value="#ffffff"
            v-model="textColour"
          />
          <label for="textWhite">Blanc</label>
          <input
            type="radio"
            id="textBlack"
            value="#000000"
            v-model="textColour"
          />
          <label for="textBlack">Noir</label>
        </div>
      </div>
    </div>
    <div class="camp-theme-colour-info">
      Choisissez une couleur en cohérence avec votre marque.
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import { useCompanyStore } from "@/stores/company.js";
import { useCampaignStore } from "@/stores/campaign.js";
import { useSpaceStore } from "@/stores/space.js";
import { getImage } from "@/composables/getImage.js";
const spaceStore = useSpaceStore();

const route = useRoute();
const companyStore = useCompanyStore();
const campaignStore = useCampaignStore();


const yuzuElemColour = "#f2cb36"; // Default background colour
const yuzuTextColour = "#000000"; // Default text colour
const selectFileText = "Choisissez un fichier"; // Default text colour

// Reactive variables
const fileName = ref(selectFileText); // Default file name
const fileSelected = ref(false); // To control the collapsed state
const elemColour = ref(yuzuElemColour); 
const textColour = ref(yuzuTextColour); 
const collapsed = ref(true); // To control the collapsed state
const selectedCampaign = ref(null); // Holds the selected campaign value

var lockCmpSelection = false;

if (campaignStore.currentCampaign) {
  if(campaignStore.currentCampaign.elem_colour) {
    elemColour.value = campaignStore.currentCampaign.elem_colour;
  }
  if(campaignStore.currentCampaign.text_colour) {
    textColour.value = campaignStore.currentCampaign.text_colour;
  }
  if(campaignStore.currentCampaign.bg_image_id) {
    fileName.value = campaignStore.currentCampaign.name;
    fileSelected.value = true;
  } 
}

// Emit function
const emit = defineEmits(['changeTextColour', 'changeThemeColour', 'toggleTheme', 'newBackground', 'setBackground', 'setHeaderImage']);

const toast = useToast();

let campaignList = [
                  {
                    id: 1,
                    name: 'Thème Yuzu par défault',
                    elemColour: yuzuElemColour,
                    textColour: yuzuTextColour,
                    backgroundImage: false,
                    headerImage: false
                  },
                ];
var index = 1; 

// Add current campaigns to list

// Get all spaces
const workspaces = await spaceStore.getSpaces(companyStore.currentCompany.company_id);

for(var i = 0; i < workspaces.length; i++) {
  await campaignStore.getCampaigns(route.params.companyId, workspaces[i].workspace_id);
}

for(var i = 0; i < campaignStore.campaigns.length; i++) {
  const campaign = campaignStore.campaigns[i];
  index += 1;
  const listElem = {
    id: index,
    campaign_id: campaign.campaign_id,
    name: campaign.name,
    elemColour: campaign.elem_colour ? campaign.elem_colour : yuzuElemColour,
    textColour: campaign.text_colour ? campaign.text_colour : yuzuTextColour,
    backgroundImage: campaign.bg_image_id,
    headerImage: campaign.image_id
  };
  campaignList.push(listElem);
}

//Add archived campaigns to list
await campaignStore.getArchivedCampaigns(route.params.companyId);

for(var i = 0; i < campaignStore.archivedCampaigns.length; i++) {
  const campaign = campaignStore.archivedCampaigns[i];

  index += 1;
  const listElem = {
    id: index,
    campaign_id: campaign.campaign_id,
    name: campaign.campaign.name,
    elemColour: campaign.elem_colour ? campaign.elem_colour : yuzuElemColour,
    textColour: campaign.text_colour ? campaign.text_colour : yuzuTextColour,
    backgroundImage: campaign.bg_image_id,
    headerImage: campaign.image_id
  };
  campaignList.push(listElem);
}

//Get total length
const campaignCount = campaignList.length;


function selectCampaign(value) {
    lockCmpSelection = true;
    // upload if no campagne or if selected campagne id is different from current
    const toUpload = (!campaignStore.currentCampaign || value.campaign_id != campaignStore.currentCampaign.campaign_id);
    
    elemColour.value = value.elemColour;
    emit('changeThemeColour', value.elemColour);
    textColour.value = value.textColour;
    emit('changeTextColour', value.textColour);
    emit('setHeaderImage', {image:value.headerImage, toUpload: toUpload});
    if(value.backgroundImage) {
      const imageBGUrl = getImage(value.backgroundImage);
      emit('setBackground', {image:imageBGUrl, toUpload: toUpload}); // Emit the image URL to parent
      
      fileName.value = value.name;
      fileSelected.value = true;
    }
    else {
      fileName.value = selectFileText;
      fileSelected.value = false;
      emit('setBackground', false);
    }
    //lockCmpSelection = false;
    setTimeout(() => {  lockCmpSelection = false;  }, 100);
}

// Function to reset v-select value for editing
function resetSelection() {
  if(!lockCmpSelection) {
    selectedCampaign.value = null; // Reset the selection
  }
}
//In order for it to be called by parent
defineExpose({resetSelection})

// Handle file upload and set the file name
const handleFileUpload = (event) => {
  const file = event.target.files[0];

  const maxSize = 1024 * 2048; // 2Mo

  if (file) {
    if (!["image/png", "image/jpeg", "image/gif"].includes(file.type)) {
      toast.error("Format de fichier non autorisé");
      return;
    }

    if (file.size > maxSize) {
      toast.error(
        "Le poids de l'image dépasse 2Mo, veuillez ressayer avec une image plus légère."
      );
      return;
    }
    fileName.value = file.name;
    fileSelected.value = true;
    emit('newBackground', file); // Emit the image URL to parent

    resetSelection();
  }
};

function removeBackground() {
  fileName.value = selectFileText;
  fileSelected.value = false;
  emit('newBackground', false);
  resetSelection();
}

// Toggle collapse state
const toggleCollapse = () => {
  collapsed.value = !collapsed.value;
  emit('toggleTheme', collapsed.value);
};

// Watch for changes to the textColour and elemColour to emit events
watch(textColour, (newColour) => {
  emit('changeTextColour', newColour);
  resetSelection();
});

watch(elemColour, (newColour) => {
  emit('changeThemeColour', newColour);
  resetSelection();
});
</script>

<!-- <style scoped> -->
<style>
.camp-theme-card {

  width: 650px;
  height: 580px;
  background-color: #1D1D1D;
  color: #fff;
  padding: 24px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border: 2px solid #464646;
}

.camp-theme-title {
  padding-top: 16px;
  font-family: "Bio Sans-Bold", Helvetica;
  font-weight: 700;
  color: #ffffff;
  font-size: 20px;
  letter-spacing: 0;
  line-height: normal;
}

.camp-theme-text {
  padding-top: 8px;
  font-family: "Bio Sans-Italic", Helvetica;
  font-style: italic;
  color: #ffffff80;
  font-size: 16px;
  letter-spacing: 0;
  line-height: normal;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--light-grey-color);
}

.camp-theme-select-title{
  padding-top: 8px;
  padding-bottom: 8px;
}

.camp-theme-selector {
  .v-select .vs__dropdown-toggle .vs__selected  {
    color: #ffffff!important;
  }
}

.camp-theme-upload-title{
  padding-top: 16px;
  font-family: "Bio Sans-Regular", Helvetica;
  color: #ffffff;
  font-size: 16px;
}

.camp-theme-upload-selector {
  margin-top: 8px;
  border-radius: 4px 0px 0px 4px;
  border: 1px solid;
  border-color: #5a5a5a;
  display: flex;
  align-items: center;
}

.camp-theme-upload-selector-bt {
  padding: 12px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  min-width: 150px;
  font-weight: bold;  
  font-family: "Bio Sans-Regular", Helvetica;
  font-weight: 400;
  color: #ffffff;
  font-size: 16px;
  border-right: 1px solid #5a5a5a;
  cursor: pointer;
  &:hover {
      background-color: #000000;
  }
                
}

.camp-theme-upload-input {
  display: none;
}

.camp-theme-upload-file-name {
  padding-left: 12px!important;
  border: none!important;
  color: #ffffff80!important;
  flex-basis: 100%;
}

.camp-theme-remove-file {
  padding-right: 12px;
  cursor: pointer;
}

.camp-theme-upload-file-info {
  margin-top: 8px;
  font-size: 14px;
  font-family: "Bio Sans-Italic", Helvetica;
  font-style: italic;
  color: #ffffff80;
}

.camp-theme-colour-section {
  display: flex;
  gap: 16px;
}

.camp-theme-colour-subsection {
  display: flex;
  margin-top: 8px;
}


.camp-theme-colour-title{
  padding-top: 16px;
  font-family: "Bio Sans-Regular", Helvetica;
  color: #ffffff;
  font-size: 16px;
}

.camp-theme-colour-picker {
  border: none; /* Remove the default border */
  outline: none; /* Remove the outline when focused */
  padding: 0px!important;
  margin: 0px!important;
  width: 65px;
  height: 48px;
  cursor: pointer;
  background: none; /* Remove background to prevent any default styling */
  -webkit-appearance: none; /* Remove default webkit appearance */
}
.camp-theme-colour-picker::-webkit-color-swatch {
  border: none; /* Remove the default swatch border in WebKit browsers */
  border-radius: 4px;
}

.camp-theme-colour-picker::-moz-color-swatch {
  border: none; /* Remove the default swatch border in Firefox */
  border-radius: 4px;
}

.camp-theme-colour-code {
  width: 100px;
  background-color: #444;
  border: none;
  padding: 0px!important;
  padding-left: 12px!important;
  margin: 3.5px!important;
  font-weight: 400;
  color: #ffffff!important;
  font-size: 16px;
}

.camp-theme-text-colour {
  margin-top: 8px;
  display: flex;
  padding-top: 12px;
  gap: 16px;
}

.camp-theme-colour-info{
  margin-top: 8px;
  font-size: 14px;
  font-family: "Bio Sans-Italic", Helvetica;
  font-style: italic;
  color: #ffffff80;
}

.camp-open-theme-zone {
  position: absolute;
  display: flex;
  flex-direction: row;

  .tooltip1 {
      display: inline-block;
      position: relative;
      max-height: 36px;
      min-width: 292px;
      background-color: #1D1D1D; /* Black background with transparency */
      color: white;
      margin-left: 12px;
      padding: 10px 10px 30px 10px;
      border-radius: 8px;
      font-size: 14px;
      border: 2px solid #464646 ;
    }

  /* Optional arrow style */
  .tooltip1::before {
      content: '';
      position: absolute; 
      left: -20px;
      bottom: 4px;
      border-width: 10px;
      border-top: 15px solid transparent;
      border-bottom: 15px solid transparent;
      border-left: 15px solid transparent;
      border-right: 15px solid #1D1D1D;
  }
}

.camp-toogle-theme-bt {
  position: relative; 
  display: flex;
  align-items: center;
  padding: 10px!important;
  background-color: #1d1d1d;
  border-radius: 4px;
  border: 2px solid;
  border-color: #464646!important;
}

</style>
